import { RenderIf } from 'components/RenderIf'
import { CCConfirmation } from './CCConfirmaion'
import { QRMConfirmation } from './QRMConfirmation'

export const PaymentConfirmation = () => {
  return (
    <>
      <RenderIf condition={process.env.REACT_APP_IS_CLIC === '0'}>
        <QRMConfirmation />
      </RenderIf>
      <RenderIf condition={process.env.REACT_APP_IS_CLIC === '1'}>
        <CCConfirmation />
      </RenderIf>
    </>
  )
}
